module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "fm"
  }, [_c('i', [_vm._v("Let us, my brethren who have not our names in the Red Book, console ourselves by thinking comfortably how miserable our betters may be, and that Damocles, who sits on satin cushions, and is served on gold plate, has an awful sword hanging over his head in the shape of a bailiff, or an hereditary disease, or a family secret, which peeps out every now and then from the embroidered arras in a ghastly manner, and will be sure to drop one day or the other in the right place")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "fm1"
  }, [_c('i', [_vm._v("In comparing, too, the poor man’s situation with that of the great, there is … another source of comfort for the former. You who have little or no patrimony to bequeath or inherit, may be on good terms with your father or your son, whereas the heir of a great prince … must naturally be angry at being kept out of his kingdom, and eye the occupant of it with no very agreeable glances")]), _vm._v(".… "), _c('i', [_vm._v("If you were heir to a dukedom and a thousand pounds a day, do you say you would not wish for possession? Pooh!")])]), _vm._v(" "), _c('p', {
    staticClass: "fm2"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("WILLIAM MAKEPEACE THACKERAY")]), _vm._v(",")]), _vm._v(" "), _c('p', {
    staticClass: "fm3"
  }, [_c('i', [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("VANITY FAIR")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-335a713d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/frontmatter01.vue
// module id = 72
// module chunks = 0